@use "../../../node_modules/@thelabnyc/breakpoint-sass/stylesheets/breakpoint";
@use "../../styles/layout";

.container {
    min-height: 100vh;
}

.navLinks {
    display: flex;
    justify-content: flex-start;
    margin: 0.8125rem 1rem;
}

.moreLocationsLink {
    align-items: center;
    color: var(--color-lobster);
    cursor: pointer;
    display: flex;
    font-size: 1.25rem;
    text-decoration: none;

    &::before {
        background-color: var(--color-lobster);
        content: "";
        display: inline-block;
        height: 18px;
        margin-right: 0.25rem;
        mask-image: url("../icons/chevron-left.svg");
        mask-position: center;
        mask-repeat: no-repeat;
        mask-size: 18px 18px;
        min-width: 18px;
    }

    &:hover {
        color: var(--color-black);

        &::before {
            background-color: var(--color-black);
        }
    }
}

.locations {
    display: grid;
    grid-template-columns: 33% 33% 33%;
    margin-left: auto;
    margin-right: auto;
    max-width: 75rem;
    padding: 50px 0 0;
    row-gap: 50px;
    width: 80%;

    @include breakpoint.breakpoint(layout.$belowMedium) {
        grid-template-columns: 1fr;
        text-align: center;
    }

    & li {
        list-style: none;
        margin: 0;
        padding: 0;
    }
}

.link {
    color: var(--color-lobster);
    text-decoration: none;
    text-transform: uppercase;

    &:hover {
        color: var(--color-black);

        & strong {
            color: var(--color-lobster);
        }
    }

    & address {
        font-style: normal;
        line-height: 1.75;
    }
}
